export default __webpack_public_path__ + "static/media/bg_facepay_by_bank2.1db90a26.png";